import React, { useContext, useState, useEffect } from 'react';

import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import ActionsDropdown from '../../components/panel/actions-dropdown.jsx';
import RecordInfos from '../../components/panel/record-infos.jsx';
import CoalSpecifications from '../../components/panel/coal-specifications.jsx';
import CoalImageGallery from '../../components/panel/coal-image-gallery.jsx';
import PageHeaderFixed from '../../components/page-header/page-header-fixed.jsx';
import RelatoriosCarvao from './relatorios-pdf-carvao.jsx';
import useCoalActions from '../../hooks/useCoalActions.js';
import { AppSettings } from '../../config/app-settings.js';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import coalService from '../../services/CoalService/coal-service.js';
import fieldService from '../../services/CoalService/field-service.js';
import ImageViewerModal from '../../components/panel/image-viewer-modal.jsx';

export default function VisualizaCarvao() {
    const { idToken } = useParams();
    const history = useHistory();
    const { user, ...settings } = useContext(AppSettings);
    const { t, i18n } = useTranslation();

    const [ selectedCoal, setSelectedCoal ] = useState(null);
    const [ fieldList, setFieldList ] = useState(null);
    const [ imageModal, setImageModal ] = useState({ images: [], index: -1 });

    const afterCoalDelete = () => {
        setTimeout(() => {
            window.close(); // aba não fechou (acesso direto pela URL/favorito/refresh): avisa e só então redireciona
            settings.handleSetAlert('info', '', t('carvão.result.botão.alerta.registroDeletado'));
            setTimeout(() => history.push('/pesquisa'), 1500);
        }, 1500);
    }

    const {
        printCoalList, coalReportModal, coalDeleteModal, historyModal, historyList,
        closeHistoryModal, openReportModal, openDeleteModal,
        handleReportType, coalHistory,
        publishCoal, unpublishCoal, editCoal, deleteCoal
    } = useCoalActions(selectedCoal, setSelectedCoal, fieldList, undefined, afterCoalDelete);

    useEffect(() => {
        fieldService.getAllFields().then(
            response => { setFieldList(response.data); }
        ).catch(
            err => { console.log(err); }
        )
    }, [i18n.language])

    useEffect(() => {
        if(fieldList) getCoalInfo(idToken);
    }, [fieldList, idToken])

    const getCoalEspecs = (data) => {
        let especificacoes = [];
        const checked = data.checked_ids || [];

        fieldList?.forEach(function (tab) {
            var espec = { tab: tab['name_' + i18n.language], fields: [], id: tab.id };
            tab.children?.forEach(function (label) {
                if (label.type == 'multi-select') {
                    var f = { name: label['name_' + i18n.language], values: [], id: label.id };
                    label.children?.forEach(function (option) {
                        if (option.type == 'multi-select-option') {
                            var v = { name: option['name_' + i18n.language], id: option.id };
                            if (checked.includes(option.id)) f.values.push(v);
                            option.children?.forEach(function (mso) {
                                if (mso.type == 'mso-child') {
                                    var vc = { name: mso['name_' + i18n.language], id: mso.id };
                                    if (checked.includes(mso.id)) f.values.push(vc);
                                }
                            });
                        }
                    });
                    if (f.values.length > 0) espec.fields.push(f);
                }
            });
            if (espec.fields.length > 0) especificacoes.push(espec);
        });

        return especificacoes;
    }

    const getCoalInfo = async (id) => {
        try {
            const response = await coalService.getInfoCoal(id);
            response.data.espec = getCoalEspecs(response.data);
            setSelectedCoal(response.data);
            window.scrollTo(0, 0);
        } catch (err) {
            settings.handleSetAlert('danger', t('alerta.titulo.erro'), t('alerta.algoDeuErrado.mensagem'));
            console.log(err);
        }
    }

    const handleCoalDelete = () => {
        deleteCoal();
        openDeleteModal();
    }

    return(
        <>
            {
                (selectedCoal && fieldList) &&
                <>
                    <PageHeaderFixed title={t('carvão.result.visualizacaoRegistro')} className="screen-content" rowClassName="screen-content">
                        <div className='col'>
                            <Panel>
                                <PanelHeader noButton={true} className='p-2 h-40px'>
                                    <div className="d-flex flex-row justify-content-end">
                                        <ActionsDropdown
                                            selectedCoal={selectedCoal}
                                            user={user}
                                            hideView={true}
                                            onReport={openReportModal}
                                            onPublish={publishCoal}
                                            onUnpublish={unpublishCoal}
                                            onHistory={coalHistory}
                                            onEdit={editCoal}
                                            onDelete={openDeleteModal}
                                        />
                                    </div>
                                </PanelHeader>
                                <PanelBody className="fs-13px">
                                    <RecordInfos selectedCoal={selectedCoal} fullScreen={true} />
                                    <CoalSpecifications selectedCoal={selectedCoal} fieldList={fieldList} />
                                    <CoalImageGallery images={selectedCoal.images} onImageClick={(i) => setImageModal({ images: selectedCoal.images.map(img => img.photo), index: i })} />
                                </PanelBody>
                            </Panel>
                        </div>

                        <Modal isOpen={coalReportModal} toggle={openReportModal} className="screen-content">
                            <ModalHeader
                                toggle={openReportModal}
                                close={
                                    <button className="btn-close" onClick={openReportModal}></button>
                                }>
                                    <i className="fa fa-circle-exclamation"></i> {t('carvão.result.botão.relatorio')}
                            </ModalHeader>

                            <ModalBody>
                                <div className="alert mb-0 fs-5">
                                    <p>{t('relatório.modal.texto')}</p>
                                </div>
                            </ModalBody>

                            <ModalFooter>
                                <button className="btn btn-secondary fs-11px" onClick={openReportModal}>
                                    {t('botão.cancelar')}</button>
                                <button className="btn btn-primary fs-11px" type="submit" onClick={ () => (handleReportType("coal-pdf"))}>
                                    {t('relatório.botão.pdf')}</button>
                                <button className="btn btn-success fs-11px" type="submit" onClick={ () => (handleReportType("coal-rtf"))}>
                                    {t('relatório.botão.rtf')}</button>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={coalDeleteModal} toggle={openDeleteModal}>
                            <ModalHeader toggle={openDeleteModal} close={<button className="btn-close" onClick={openDeleteModal}></button>}><i className="fa fa-circle-exclamation"></i> {t('modal.atenção')}</ModalHeader>
                                <ModalBody>
                                    <div className="alert mb-0 fs-5">
                                        <p>{t('carvão.result.modal.remover.texto1')}</p>
                                        <p>{t('carvão.result.modal.remover.texto2')}</p>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <button className="btn btn-secondary" onClick={openDeleteModal}>{t('botão.cancelar')}</button>
                                    <button className="btn btn-danger" onClick={() => handleCoalDelete()} type="submit" >
                                    {t('gerencia.botão.removerComCerteza')}</button>
                                </ModalFooter>
                        </Modal>

                        <ImageViewerModal images={imageModal.images} startIndex={imageModal.index}  isOpen={imageModal.index >= 0} onClose={() => setImageModal(m => ({ ...m, index: -1 }))} />

                        <Modal isOpen={historyModal} toggle={closeHistoryModal}>
                            <ModalHeader
                                toggle={closeHistoryModal}
                                close={
                                    <button className="btn-close" onClick={closeHistoryModal}></button>
                                }>
                            </ModalHeader>
                            <ModalBody>
                                <div className="row">
                                    <div className="col">
                                        {
                                            historyList?.map(value => {
                                                let typeString;
                                                switch (value.tipo) {
                                                    case 1:
                                                        typeString = t('carvão.result.historico.criar');
                                                        break;
                                                    case 2:
                                                        typeString = t('carvão.result.historico.editar');
                                                        break;
                                                    case 3:
                                                        typeString = t('carvão.result.historico.publicar');
                                                        break;
                                                    case 4:
                                                        typeString = t('carvão.result.historico.privar');
                                                        break;
                                                    case 5:
                                                        typeString = t('carvão.result.historico.inativado');
                                                        break;
                                                    case 6:
                                                        typeString = t('carvão.result.historico.relatorio');
                                                        break;
                                                    default:
                                                        break;
                                                }
                                                return (
                                                    <div className="row ">
                                                        <div className="col w-50">
                                                            <p>{t('carvão.result.historico.texto1')} <b>{typeString}</b> {t('carvão.result.historico.em')} <b>{value.data}</b> {t('carvão.result.historico.por')} <b>{value.name}</b>.</p>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>
                    </PageHeaderFixed>

                    <RelatoriosCarvao printCoalList={printCoalList} fieldList={fieldList}></RelatoriosCarvao>
                </>
            }
        </>
    )
}